export const RenderComponentCondition = ({
  listCondition,
  current,
  children
}) => _.includes(listCondition, current) && children;

export default RenderComponentCondition;
